/* eslint-disable no-unused-vars */
import echarts from 'echarts/lib/echarts'
/* import { legend } from 'echarts/lib/theme/dark' */
const myMixinfault = {
  mounted: function () {

  },
  watch: {
  },
  methods: {
    drawLine_aa () {
      var vm = this
      let data = [{
        name: '行波模块',
        precent: vm.dtuInstallData.kgDtubfb,
        value: vm.dtuInstallData.kgDtuCount
      },
      {
        name: '架空型',
        precent: vm.dtuInstallData.jkDtubfb,
        value: vm.dtuInstallData.jkDtuCount
      },
      {
        name: '电缆型',
        precent: vm.dtuInstallData.dlDtubfb,
        value: vm.dtuInstallData.dlDtuCount
      }]
      let arrName = getArrayValue(data, 'name')
      let arrValue = getArrayValue(data, 'value')
      // eslint-disable-next-line no-eval
      let sumValue = eval(arrValue.join('+'))
      let objData = array2obj(data, 'name')
      let optionData = getData(data)

      function getArrayValue (array, key) {
        var key1 = key || 'value'
        var res = []
        if (array) {
          array.forEach(function (t) {
            res.push(t[key])
          })
        }
        return res
      }

      function array2obj (array, key) {
        var resObj = {}
        for (var i = 0; i < array.length; i++) {
          resObj[array[i][key]] = array[i]
        }
        return resObj
      }

      function getData (data) {
        var res = {
          series: [],
          yAxis: []
        }
        for (let i = 0; i < data.length; i++) {
          res.series.push({
            name: '',
            type: 'pie',
            clockWise: false, // 顺时加载
            hoverAnimation: false, // 鼠标移入变大
            radius: [100 - i * 25 + '%', 87 - i * 25 + '%'],
            center: ['75%', '50%'],
            color: ['#10D3C4', '#09B1F4', '#F2B12F'],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              borderWidth: 5
            },
            data: [{
              value: data[i].value,
              name: data[i].name
            }, {
              value: sumValue - data[i].value,
              name: '',
              itemStyle: {
                color: 'rgba(0,0,0,0)',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }]
          })
          res.series.push({
            name: '',
            type: 'pie',
            silent: true,
            z: 1,
            clockWise: false, // 顺时加载
            hoverAnimation: false, // 鼠标移入变大
            radius: [100 - i * 25 + '%', 87 - i * 25 + '%'],
            center: ['75%', '50%'],
            color: ['#11E0CE', '#09B1F4', '#F2B12F'],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              borderWidth: 5
            },
            data: [{
              value: 7.5,
              itemStyle: {
                color: '#C8DDE9',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }, {
              value: 2.5,
              name: '',
              itemStyle: {
                color: 'rgba(0,0,0,0)',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }]
          })
          res.yAxis.push((data[i].value / sumValue * 100).toFixed(2) + '%')
        }
        return res
      }
      // 为charts选定父容器并初始化charts画布
      let myChart = vm.$echarts.init(document.getElementById('chart1'))

      // 为图表添加数据
      myChart.setOption({
        legend: {
          selectedMode: true, // 取消图例上的点击事件
          type: 'plain',
          icon: 'circle',
          orient: 'vertical',
          left: '0',
          top: '8px',
          align: 'left',
          itemGap: 18,
          itemWidth: 6, // 设置宽度
          itemHeight: 6, // 设置高度
          symbolKeepAspect: false,
          textStyle: {
            color: '#000',
            rich: {
              name: {
                verticalAlign: 'left',
                align: 'left',
                width: 70,
                fontSize: 12
                // backgroundColor:'red'
              },
              precent: {
                align: 'left',
                width: 40,
                fontSize: 12
              },
              value: {
                align: 'left',
                width: 40,
                fontSize: 12
              }
            }
          },
          data: data.map(item => item.name),
          formatter: function (name) {
            if (data && data.length) {
              for (var i = 0; i < data.length; i++) {
                if (name === data[i].name) {
                  return (
                    '{name| ' +
                               name +
                               '}' +
                               '{precent| ' +
                               data[i].precent +
                               '%}' +
                               '{value| ' +
                               data[i].value +
                               '台}'

                  )
                }
              }
            }
          }
        },
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: '{a}<br>{b}:{c}({d}%)'
        },
        color: ['rgb(24, 183, 142)', 'rgb(1, 179, 238)', 'rgb(22, 75, 205)', 'rgb(52, 52, 176)'],
        xAxis: [{
          show: false
        }],
        series: optionData.series
      })
    },
    drawLine_bb () {
      let vm = this
      // 为charts选定父容器并初始化charts画布
      let myChart = vm.$echarts.init(document.getElementById('chart2'))
      const data = [{
        name: '接地',
        value: vm.MlineDiaresData.jdCount
      },
      {
        name: '速断',
        value: vm.MlineDiaresData.sdCount
      },
      {
        name: '过流',
        value: vm.MlineDiaresData.glCount
      },
      {
        name: '瞬时性短路',
        value: vm.MlineDiaresData.ssxdlCount
      }]
      const total = data.reduce((tot, num) => { // 数值的总数，用来计算百分比
        return (tot.value ? tot.value : tot) + num.value / 200
      })
      const colors = ['#10D3C4', '#F2B12F', '#097EF4', '#E85B45'] // 自定义颜色组
      const arr = []
      data.map((item, index) => {
        arr.push({
          radius: ['41%', '51%'],
          center: [(index % 4) * 25 * 1 + 12.5 + '%', data.length > 4 ? (index < 4 ? '25%' : '70%') : '50%'],
          hoverAnimation: false,
          clockwise: false,
          type: 'pie',
          label: {
            show: true,
            position: 'center',
            formatter: [
              '{b|{b}}',
              '{d|' + (item.value) + '}'
              // '{d|' + (item.value / total * 100).toFixed(2) + '%}'
            ].join('\n'),
            rich: {
              b: {
                color: '#353535',
                fontSize: 11,
                // fontFamily: '楷体',
                fontWeight: 400,
                height: 30
              },
              d: {
                // fontFamily: 'cursive',
                color: colors[index],
                fontSize: 13
              }
            }
          },
          data: [{
            ...item,
            itemStyle: {
              normal: {
                color: colors[index]
              },
              emphasis: {
                color: colors[index]
              }
            }
          },
          {
            value: total,
            itemStyle: {
              normal: {
                color: '#C8DDE9'
              },
              emphasis: {
                color: '#C8DDE9'
              }
            }
          }
          ]
        })
      })
      // 为图表添加数据
      myChart.setOption({
        backgroundColor: 'rgba(0,0,0,0)',
        xAxis: {
          show: false
        },
        yAxis: {
          show: false
        },
        series: arr
      })
    }
  }
}
export default myMixinfault
